import "../utilities/ApiConstants";
import axios, { AxiosInstance, AxiosResponse } from "axios";
import {
    demoAPIRoot1,
    demoHostname1,
    demoPartialHostname,
    demoDynamicAPIRoot,
    development01APIRoot,
    development01Hostname,
    developmentLoadBalancedAPIRoot,
    developmentLoadBalancedHostname,
    localAPIRoot,
    localHostname,
    productionDynamicAPIRoot,
    productionPartialHostname,
    productionLoadBalanceAPIRoot,
    productionLoadBalancedHostname,
    stagingAPIRoot,
    stagingHostname,
    drAPIRoot,
    drHostname,
    stagingKeycloakHostname,
    stagingKeycloakAPIRoot
} from "../utilities/ApiConstants";

let backendHost: string = development01APIRoot;
const hostname = window && window.location && window.location.hostname;

let environment: string = "localhost";
let dashboardURL : string = "";

if (hostname === localHostname) {
    backendHost = localAPIRoot;
    dashboardURL = "https://portal.inceptia.org";
    //backendHost = developmentLoadBalancedAPIRoot;
} else if (hostname === development01Hostname) {
    //Dev 01
    backendHost = development01APIRoot;
    environment = 'DEVELOPMENT';
    dashboardURL = "https://portal.inceptia.org";
} else if (hostname === developmentLoadBalancedHostname) {
    //Load balanced dev
    environment = 'DEVELOPMENT';
    dashboardURL = "https://portal.inceptia.org";
    backendHost = developmentLoadBalancedAPIRoot;
} else if (hostname === demoHostname1) {
    //Demo env
    environment = 'DEMO';
    dashboardURL = "https://portal.inceptia.org";
    backendHost = demoAPIRoot1;
} else if (hostname.includes(demoPartialHostname)) {
    //Demo env
    environment = 'DEMO';
    dashboardURL = "https://portal.inceptia.org";
    backendHost = demoDynamicAPIRoot(hostname.split(".")[0]);
} else if (hostname === stagingHostname) {
    //Staging env
    environment = 'STAGING';
    dashboardURL = "https://portal.inceptia.org";
    backendHost = stagingAPIRoot;
} else if (hostname === stagingKeycloakHostname) {
    //Staging env
    environment = 'STAGING-KEYCLOAK';
    dashboardURL = "https://portal.inceptia.org";
    backendHost = stagingKeycloakAPIRoot;
} else if (hostname === drHostname) {
    //DR env
    environment = 'DR';
    dashboardURL = "https://portal.inceptia.org";
    backendHost = drAPIRoot;
} else if (hostname === productionLoadBalancedHostname) {
    environment = 'PRODUCTION';
    dashboardURL = "https://portal.inceptia.org";
    backendHost = productionLoadBalanceAPIRoot;
} else if (hostname.includes(productionPartialHostname)) {
    environment = 'PRODUCTION';
    dashboardURL = "https://portal.inceptia.org";
    backendHost = productionDynamicAPIRoot(hostname.split(".")[0]);
} else {
    console.log("other Hostname: ");
    console.log(hostname);
    backendHost = demoAPIRoot1;
}
//Set global school code
export const API_ROOT: string = `${backendHost}`;
export const WEBSOCKET_API_ROOT: string = `${backendHost.replace("https", "wss")}`;

// This is the environment that the front-end is hitting. 
export const ENVIRONMENT: string = environment;
export const DASHBOARDURL: string = dashboardURL;

export async function awaitableRootSchoolCode(): Promise<string> {
    try {
        // Now that we have the API root, find the school code
        const hash: string = window.location.hash;
        const hashArgs: string[] = hash.split("/");

        // create a new api instance to avoid circular dependency with AuthService
        axios.defaults.withCredentials = true;
        const initialApi: AxiosInstance = axios.create({
            baseURL: `${API_ROOT}/api`,
        });

        // If there is a domain parameter, use it. Otherwise, use the first piece of the hostname (prior to .verificationgateway.org or .vgdemo.org)
        let searchableUrl: string | undefined =
            (["login", "forgotPassword", "studentLookup"].includes(
                hashArgs[1]
            ) &&
                hashArgs.length === 3) ||
                (["studentAccountCreation"].includes(hashArgs[1]) &&
                    hashArgs.length > 5 &&
                    /^[a-zA-Z]\w+$/.test(hashArgs[hashArgs.length - 1])) ||
                (["resetPassword"].includes(hashArgs[1]) && hashArgs.length > 5)
                ? hashArgs.pop()
                : hostname.split(".")[0];

        const resp: AxiosResponse<string> = await initialApi.get(
            `/auth/getSchoolCodeFromURL/${searchableUrl}`);
        return resp.data;
    } catch (err) {
        return "222222"; // keep 222222 as the default school code becasue it exists on all environments
    }
};